export default __webpack_public_path__ + "static/media/workspace.6a2abec1.svg";